import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { FarmerValidationPage } from '@contracts';

export const Route = createFileRoute('/farmer-validation')({
  validateSearch: z.object({
    token: z.string(),
  }),
  component: FarmerValidationPage,
});
